import { CTA_VARIANT } from "../../constants/cta";
import { TEXT_ALIGNMENT } from "../../constants/design";
import { targetPropType } from "../../constants/target";
import { NeutralColors, UIPalette } from "../../constants/colors";
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import BannerLink from "./banner-link";
import BannerPrimary from "./banner-primary";
import { StyledBannerContainer } from "./base.styles";
import { DISPLAY_TYPE } from "./constants";
import { jsx as _jsx } from "react/jsx-runtime";
var Banner = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var backgroundColor = _ref.backgroundColor,
    color = _ref.color,
    cta = _ref.cta,
    ctaVariant = _ref.ctaVariant,
    dismissible = _ref.dismissible,
    dismissButtonLabel = _ref.dismissButtonLabel,
    displayType = _ref.displayType,
    message = _ref.message,
    onDismiss = _ref.onDismiss,
    textAlign = _ref.textAlign;
  var banner;
  switch (ctaVariant) {
    case CTA_VARIANT.Link:
      banner = /*#__PURE__*/_jsx(BannerLink, {
        backgroundColor: backgroundColor,
        color: color,
        cta: cta,
        dismissible: dismissible,
        dismissButtonLabel: dismissButtonLabel,
        message: message,
        onDismiss: onDismiss
      });
      break;
    case CTA_VARIANT.Primary:
      banner = /*#__PURE__*/_jsx(BannerPrimary, {
        backgroundColor: backgroundColor,
        color: color,
        cta: cta,
        dismissible: dismissible,
        dismissButtonLabel: dismissButtonLabel,
        message: message,
        onDismiss: onDismiss
      });
      break;
    default:
      banner = null;
  }
  return /*#__PURE__*/_jsx(StyledBannerContainer, {
    displayType: displayType,
    ref: ref,
    textAlign: textAlign,
    children: banner
  });
});
Banner.propTypes = {
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
  cta: PropTypes.shape({
    url: PropTypes.string,
    text: PropTypes.string,
    target: targetPropType
  }),
  ctaVariant: PropTypes.oneOf(Object.values(CTA_VARIANT)),
  dismissible: PropTypes.bool,
  dismissButtonLabel: PropTypes.string,
  displayType: PropTypes.oneOf(Object.values(DISPLAY_TYPE)),
  message: PropTypes.node.isRequired,
  onDismiss: PropTypes.func,
  textAlign: PropTypes.oneOf(Object.values(TEXT_ALIGNMENT))
};
Banner.defaultProps = {
  backgroundColor: UIPalette.Emerald,
  color: NeutralColors.White,
  cta: null,
  ctaVariant: CTA_VARIANT.Link,
  dismissible: false,
  dismissButtonLabel: 'Dismiss banner',
  displayType: DISPLAY_TYPE.FIXED,
  onDismiss: null,
  textAlign: TEXT_ALIGNMENT.LEFT
};
export default /*#__PURE__*/memo(Banner);